import React, { useEffect } from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Modal,
  ImageBackground,
  Dimensions,
} from "react-native";
import { useDevice } from "../../../utils/hooks/useDevice";
import LeveledUp from "../../../assets/popup/modal_level_up.png";
import { analyticsEvents } from "../../../services/firebase/analytics-events.service";
import { cleverTapService } from "../../../services/clevertap/clevertap.service";

interface IProps {
  visible: boolean;
  level: number;
  onClose: () => void;
}

const LevelNumber = ({ level }: { level: number }) => {
  return (
    <View style={styles.levelContainer}>
      <Text style={[styles.levelStroke, { left: -3, top: 0 }]}>{level}</Text>
      <Text style={[styles.levelStroke, { left: 3, top: 0 }]}>{level}</Text>
      <Text style={[styles.levelStroke, { left: 0, top: -3 }]}>{level}</Text>
      <Text style={[styles.levelStroke, { left: 0, top: 3 }]}>{level}</Text>
      <Text style={[styles.levelStroke, { left: -3, top: -3 }]}>{level}</Text>
      <Text style={[styles.levelStroke, { left: 3, top: -3 }]}>{level}</Text>
      <Text style={[styles.levelStroke, { left: -3, top: 3 }]}>{level}</Text>
      <Text style={[styles.levelStroke, { left: 3, top: 3 }]}>{level}</Text>
      <Text style={styles.levelMain}>{level}</Text>
    </View>
  );
};

const LeveledUpNotificationModal: React.FC<IProps> = ({
  visible,
  level,
  onClose,
}) => {
  const { isDesktop } = useDevice();
  const screenWidth = Dimensions.get("window").width;
  const modalWidth = isDesktop
    ? Math.min(screenWidth * 0.42, 600)
    : screenWidth * 0.5;

  const modalHeight = modalWidth * 0.7269;
  analyticsEvents.trackLevelUp(level);
  cleverTapService.trackEvent("Level Up", {
    new_level: level,
  });
  useEffect(() => {
    if (visible) {
      const timer = setTimeout(() => onClose(), 3000);
      return () => clearTimeout(timer);
    }
  }, [visible]);

  return (
    <Modal visible={visible} transparent animationType="fade">
      <TouchableOpacity
        style={styles.overlay}
        activeOpacity={1}
        onPress={onClose}
      >
        <ImageBackground
          source={LeveledUp}
          style={[styles.bg, { width: modalWidth, height: modalHeight }]}
          resizeMode="contain"
        >
          <LevelNumber level={level} />
        </ImageBackground>
      </TouchableOpacity>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: "rgba(0,0,0,0.6)",
    justifyContent: "center",
    alignItems: "center",
  },

  bg: {
    justifyContent: "center",
    alignItems: "center",
  },

  levelContainer: {
    position: "absolute",
    top: "50%",
    alignItems: "center",
    justifyContent: "center",
    transform: [{ translateY: -65 }],
  },

  levelMain: {
    color: "#FFD84A",
    fontSize: 130,
    fontWeight: "900",
    textShadowColor: "rgba(200, 0, 0, 0.7)",
    textShadowOffset: { width: 2, height: 2 },
    textShadowRadius: 4,
  },

  levelStroke: {
    position: "absolute",
    color: "white",
    fontSize: 130,
    fontWeight: "900",
  },
});

export default LeveledUpNotificationModal;
